module.exports = __webpack_public_path__ + "assets/img/icon2.8895cb1b.svg";